// @flow
import merge from 'lodash/merge';
import type { EnvironmentConfig } from 'model/EnvironmentConfig';
import staging from 'appconfig/envs/staging';

const devEnvHostname = window.location.hostname.replace(/^cart-/, '');

export default (): EnvironmentConfig =>
  merge(staging(), {
    clicktaleEnabled: false,
    hamsUrl: `https://hamlet-${devEnvHostname}`,
    sentry: {
      environment: `branch-${devEnvHostname}`,
    },
    i18nUrl: 'https://cart-static.ap-southeast-2.dev.public.atl-paas.net/i18n',
    root: 'http://localhost:3000/purchase',
    ppcUrl: 'https://ppc.dev.atlassian.com',
    bitbucketCmtUrl: 'https://integration.bb-inf.net/',
  });
